import { RootState } from '@/App/store';

export const selectUserInitialized = (state: RootState) => state.user.initialized;
